import React from 'react'

const Unauthorised = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="bg-white shadow-lg rounded-lg p-8 text-center max-w-md">
        <h1 className="text-2xl font-bold text-red-600 mb-4">Account Revoked</h1>
        <p className="text-gray-700 mb-6">
          Unfortunately, your account has been revoked.
          If you believe this is a mistake, please contact our support team for assistance.
        </p>
        <a
          href="#"
          className="bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600 transition"
        >
          support@aifinitelearning.com
        </a>
      </div>
    </div>
  );
}

export default Unauthorised
